module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/187.5873728b.png";